import { CommonModule } from '@angular/common';
import { LayoutModule } from '@angular/cdk/layout';
import { NgModule } from '@angular/core';

import { AppMatModule } from 'src/app/shared/app-mat.module';
import { NavComponent } from './nav.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { NeedsPermissionModule } from '../auth/permissions';

@NgModule({
  declarations: [NavComponent],
  imports: [AppMatModule, CommonModule, LayoutModule, RouterModule, SharedModule, NeedsPermissionModule],
  exports: [NavComponent],
})
export class NavModule {}
